import type { EnvioCampana } from '../../lib/supabase';
import type { EnvioCampanaHistorial, OwnerFondoCampana } from '../../types/fondosCampana';
import { fechaEnChile } from '../../utils/dateHelpers';
import type { EntidadDinero } from '../../utils/permissions';

export type AccionEnvioCampana = 'confirmar' | 'observar' | 'corregir' | 'cerrar';

export const ETIQUETAS_ACCION: Readonly<Record<AccionEnvioCampana, string>> = {
  confirmar: 'Confirmar recepción', observar: 'Observar rendición', corregir: 'Corregir y reenviar',
  cerrar: 'Declarar que no se transfirió',
};

export const ETIQUETAS_ESTADO: Readonly<Record<EnvioCampana['estado'], string>> = {
  pendiente: 'Enviado por confirmar', observado: 'Enviado observado', confirmado: 'Recepción confirmada',
  cerrado_sin_transferencia: 'Transferencia no realizada',
};

export function hoyEnvioChile(): string {
  const hoy = fechaEnChile(new Date());
  if (!hoy) throw new Error('No se pudo determinar la fecha de Chile.');
  return hoy;
}

export function entidadDineroDelOwner(owner: OwnerFondoCampana): EntidadDinero {
  if (owner.tipo === 'lumisial') return { tipo: 'lumisial', id: owner.id, diocesisId: null,
    provinciaEclesiasticaId: null };
  if (owner.tipo === 'diocesis') return { tipo: 'diocesis', id: owner.id, provinciaEclesiasticaId: null };
  return { tipo: 'provincia', id: owner.id };
}

export function accionesEnvioDisponibles(envio: EnvioCampana, owner: OwnerFondoCampana,
  puedeOperar: boolean): AccionEnvioCampana[] {
  if (!puedeOperar) return [];
  const origen = esOrigenEnvio(envio, owner);
  const destino = esDestinoEnvio(envio, owner);
  const acciones: AccionEnvioCampana[] = [];
  if (origen && envio.estado === 'observado') acciones.push('corregir');
  if (origen && ['pendiente', 'observado'].includes(envio.estado)) acciones.push('cerrar');
  if (destino && envio.estado === 'pendiente') acciones.push('confirmar', 'observar');
  return acciones;
}

function esOrigenEnvio(envio: EnvioCampana, owner: OwnerFondoCampana): boolean {
  return (owner.tipo === 'lumisial' && owner.id === envio.lumisial_id)
    || (owner.tipo === 'diocesis' && owner.id === envio.origen_diocesis_id);
}
function esDestinoEnvio(envio: EnvioCampana, owner: OwnerFondoCampana): boolean {
  return (owner.tipo === 'diocesis' && owner.id === envio.destino_diocesis_id)
    || (owner.tipo === 'provincia' && owner.id === envio.destino_provincia_eclesiastica_id);
}
export function motivoHistorial(evento: EnvioCampanaHistorial): string | null {
  const args = evento.argumentos;
  if (args === null || typeof args !== 'object' || Array.isArray(args)) return null;
  const motivo = args.motivo ?? args.nota ?? args.p_motivo ?? args.p_nota;
  return typeof motivo === 'string' ? motivo : null;
}
